import { APPLE_GLYPH_PATHS, toGooglePlayGlyphPaths } from 'BomdisoftComponents/store-badges/render';
import { useId } from 'react';

export const AppleGlyph = () => <svg aria-hidden='true' dangerouslySetInnerHTML={{ __html: APPLE_GLYPH_PATHS }} fill='currentColor' height='22' viewBox='0 0 24 24' width='22' xmlns='http://www.w3.org/2000/svg' />;

export const GooglePlayGlyph = () => {
  const id = useId();

  return <svg aria-hidden='true' dangerouslySetInnerHTML={{ __html: toGooglePlayGlyphPaths(id) }} height='22' viewBox='0 0 512 512' width='22' xmlns='http://www.w3.org/2000/svg' />;
};
